import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HomePage from './components/HomePage';
import EstateDetailPage from './components/EstateDetailPage';
import ListingsPage from './components/ListingsPage';
import EstatesMapPage from './components/Map/EstatesMapPage';
import RegionsPage from './components/RegionsPage';
import RegionDetailPage from './components/RegionDetailPage';
import AboutPage from "./components/AboutPage";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import DashboardPage from "./components/DashboardPage";
import ContactPage from "./components/ContactPage";
import AuthCallback from "./components/AuthCallback";
import { ROUTES } from './routeConstants';

// Separate ScrollToTop component
const ScrollToTop = () => {
        const { pathname } = useLocation();

        useEffect(() => {
                window.scrollTo({
                        top: 0,
                        behavior: 'instant'
                });
        }, [pathname]);

        return null;
};

// Custom route components with predefined filters
const PopularEstates = () => (
    <ListingsPage defaultSort="estate_total_views" />
);

const GolfEstates = () => (
    <ListingsPage defaultFilters="distance_to_golf <= 2" />
);

const BeachEstates = () => (
    <ListingsPage defaultFilters="distance_to_beach <= 1" />
);

const LuxuryEstates = () => (
    <ListingsPage defaultFilters="is_luxury:true" />
);

const AppRoutes = () => (
    <>
            <ScrollToTop />
            <Routes>
                    <Route path={ROUTES.HOME} element={<HomePage />} />
                    <Route path={ROUTES.LISTINGS} element={<ListingsPage />} />
                    <Route path={ROUTES.MAP} element={<EstatesMapPage />} />
                    <Route path={ROUTES.CONTACT} element={<ContactPage />} />
                    <Route path={ROUTES.ESTATE_DETAIL} element={<EstateDetailPage />} />
                    <Route path={ROUTES.REGIONS} element={<RegionsPage />} />
                    <Route path={ROUTES.REGION_DETAIL} element={<RegionDetailPage />} />
                    <Route path={ROUTES.ABOUT} element={<AboutPage />} />
                    <Route path={ROUTES.LOGIN} element={<LoginPage />} />
                    <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
                    <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
                    <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />
                    {/* Filtered routes */}
                    <Route path={ROUTES.POPULAR_ESTATES} element={<PopularEstates />} />
                    <Route path={ROUTES.GOLF_ESTATES} element={<GolfEstates />} />
                    <Route path={ROUTES.BEACHFRONT_HOMES} element={<BeachEstates />} />
                    <Route path={ROUTES.LUXURY_ESTATES} element={<LuxuryEstates />} />
            </Routes>
    </>
);

export default AppRoutes;